var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEslint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8080f2",
    d: "m38.662 48.67 24.26-14.04a2.187 2.187 0 0 1 1.962 0l24.363 14.04c.62.31 1.033 1.032 1.033 1.651v28.08c0 .723-.413 1.342-1.033 1.755l-24.26 14.04a2.187 2.187 0 0 1-1.962 0l-24.363-14.04c-.62-.31-1.033-1.032-1.033-1.755v-28.08c0-.62.413-1.342 1.033-1.651"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4b32c3",
    d: "m127.135 61.47-29.01-50.585c-1.032-1.858-2.993-3.2-5.161-3.2H34.945c-2.064 0-4.026 1.342-5.161 3.2L.774 61.368a6.175 6.175 0 0 0 0 5.987l29.01 50.173c1.032 1.858 2.993 2.787 5.161 2.787h58.122c2.065 0 4.026-.929 5.162-2.684l29.01-50.173c1.032-2.064 1.032-4.232-.104-5.987M103.08 85.73c0 .723-.413 1.445-1.136 1.755l-36.958 21.37a1.875 1.875 0 0 1-2.065 0l-37.06-21.266c-.62-.413-1.136-1.032-1.136-1.755V42.991c0-.722.413-1.445 1.136-1.754l37.061-21.37a1.875 1.875 0 0 1 2.065 0l37.062 21.37c.619.412 1.135 1.032 1.135 1.754v42.74z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEslint);
export default __webpack_public_path__ + "static/media/eslint.df6c5145192471990cdf28322532c742.svg";
export { ForwardRef as ReactComponent };